import { render } from "./MultiFileDisplay.vue?vue&type=template&id=000fd879"
import script from "./MultiFileDisplay.vue?vue&type=script&lang=js"
export * from "./MultiFileDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__